module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "jordan_image.91d2c13c.jpg";